
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const NameAnalysisCreateOverTimePage = lazy(() => import('./NameAnalysisCreateOverTimePage'));
const path = 'reports/subword-frequency/create-over-time';
const NameAnalysisCreateOverTimeRoute: FuseRouteItemType = {
	path: path,
	element: <NameAnalysisCreateOverTimePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis For Create',
					helpName: 'Name Analysis For Create Over Time',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default NameAnalysisCreateOverTimeRoute;
